import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Divider } from "@material-ui/core";
import { Card, Chip, Collapse, InputAdornment, Tooltip, Menu } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SchoolIcon from "@material-ui/icons/School";
import BusinessIcon from "@material-ui/icons/Business";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import EventIcon from "@material-ui/icons/Event";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import VideocamIcon from "@material-ui/icons/Videocam";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import ImagesStoreService from "./Locality/Service/imagesStoreService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import StudentService from "./Locality/Service/studentService";
import TeacherService from "./Locality/Service/teacherService";
import SchooleRegistrationService from "./Locality/Service/schooleRegistration";
const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflowX: "auto",
  },
  pageHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: "1.9rem",
    color: "#0f2d4d",
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: "#6b7280",
    fontSize: "0.9rem",
    marginTop: 2,
  },
  noteBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: "#eef4ff",
    border: "1px solid #d6e4ff",
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#1769d6",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: "1px solid #e6eaf0",
    boxShadow: "0 2px 10px rgba(16,42,67,0.06)",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  filtersChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 14px",
    borderRadius: 8,
    backgroundColor: "#f4f6fa",
    border: "1px solid #e6eaf0",
    cursor: "pointer",
    fontWeight: 600,
    color: "#0f2d4d",
    fontSize: "0.9rem",
  },
  countBadge: {
    backgroundColor: "#1769d6",
    color: "#fff",
    borderRadius: 10,
    fontSize: "0.72rem",
    fontWeight: 700,
    minWidth: 18,
    height: 18,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 5px",
  },
  fieldLabel: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#46566b",
    marginBottom: 6,
  },
  resetBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    color: "#46566b",
    border: "1px solid #e6eaf0",
  },
  tableCard: {
    borderRadius: 14,
    border: "1px solid #e6eaf0",
    boxShadow: "0 2px 10px rgba(16,42,67,0.06)",
    overflow: "hidden",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderBottom: "1px solid #eef1f5",
  },
  iconBtnOutlined: {
    border: "1px solid #e6eaf0",
    borderRadius: 8,
    padding: 7,
  },
  headCell: {
    backgroundColor: "#f4f6fa",
    color: "#46566b",
    fontWeight: 700,
    fontSize: "0.8rem",
    borderBottom: "1px solid #e6eaf0",
    whiteSpace: "nowrap",
  },
  classChip: {
    backgroundColor: "#eef4ff",
    color: "#1769d6",
    fontWeight: 600,
    height: 24,
  },
  sectionChip: {
    backgroundColor: "#f3efff",
    color: "#7c4dff",
    fontWeight: 600,
    height: 24,
  },
  studentChip: {
    backgroundColor: "#f4f6fa",
    color: "#46566b",
    fontWeight: 600,
    height: 24,
  },
  publishedChip: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    fontWeight: 600,
    height: 24,
  },
  draftChip: {
    backgroundColor: "#fff8e1",
    color: "#f57c00",
    fontWeight: 600,
    height: 24,
  },
  statusSelect: {
    minWidth: 118,
    borderRadius: 8,
    "& .MuiOutlinedInput-input": {
      padding: "5px 10px",
      fontSize: "0.8rem",
      fontWeight: 600,
    },
    "& .MuiSelect-icon": {
      right: 4,
    },
  },
  statusSelectPublished: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#a5d6a7",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#81c784",
    },
  },
  statusSelectDraft: {
    backgroundColor: "#fff8e1",
    color: "#f57c00",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ffe082",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ffca28",
    },
  },
  statusNoteBox: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
  },
  statusNoteTitle: {
    fontWeight: 700,
    fontSize: "0.8rem",
    color: "#0f2d4d",
    marginBottom: 4,
  },
  statusNoteText: {
    fontSize: "0.8rem",
    color: "#46566b",
    lineHeight: 1.5,
  },
  addBtn: {
    backgroundColor: "#1769d6",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "8px 18px",
    boxShadow: "0 4px 10px rgba(23,105,214,0.25)",
    "&:hover": { backgroundColor: "#125bbd" },
    "&.Mui-disabled": { backgroundColor: "#cbd5e1", color: "#fff" },
  },
  thumbStack: {
    display: "flex",
    alignItems: "center",
  },
  moreThumb: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: "#eef4ff",
    color: "#1769d6",
    fontSize: "0.72rem",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 4,
  },
  rowThumb: {
    width: 36,
    height: 36,
    objectFit: "cover",
    borderRadius: 8,
    marginRight: 4,
    border: "1px solid #e6eaf0",
  },
  thumb: {
    width: 48,
    height: 48,
    objectFit: "cover",
    borderRadius: 4,
    marginRight: 4,
  },
  thumbPreview: {
    width: 72,
    height: 72,
    objectFit: "cover",
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
  },
  filterRow: {
    marginBottom: theme.spacing(2),
  },
  dialogPaper: {
    borderRadius: 12,
    maxWidth: 330,
    width: "100%",
  },
  dialogTitle: {
    paddingBottom: theme.spacing(1),
    fontWeight: 600,
  },
  dialogContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    overflowY: "auto",
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  formSection: {
    marginBottom: theme.spacing(2),
  },
  sectionLabel: {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1.5),
    fontSize: "0.8125rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  fieldSpacing: {
    marginBottom: theme.spacing(2),
  },
  checkboxRow: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  imagesPanel: {
    padding: theme.spacing(2),
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.grey[50],
    position: "relative",
  },
  uploadOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    backgroundColor: "rgba(255, 255, 255, 0.94)",
    borderRadius: 8,
    padding: theme.spacing(3),
  },
  uploadOverlayTitle: {
    fontWeight: 700,
    color: "#0f2d4d",
    fontSize: "0.95rem",
  },
  uploadOverlayProgress: {
    width: "100%",
    maxWidth: 280,
  },
  uploadActions: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  previewGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1),
  },
  previewItem: {
    position: "relative",
  },
  removeThumbBtn: {
    position: "absolute",
    top: -6,
    right: -6,
    backgroundColor: "#fff",
    boxShadow: theme.shadows[1],
    padding: 4,
  },
  pendingPanel: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: 8,
    border: `1px dashed ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.paper,
  },
  pendingLabel: {
    fontSize: "0.8125rem",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  pendingFileName: {
    fontSize: "0.65rem",
    maxWidth: 72,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "center",
    marginTop: 4,
    color: theme.palette.text.secondary,
  },
  mediaTypeLabel: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#46566b",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  mediaPlayTile: {
    width: 72,
    height: 72,
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: "#0f2d4d",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
    "&:hover": {
      backgroundColor: "#1769d6",
    },
  },
  mediaPlayIcon: {
    color: "#fff",
    fontSize: 36,
  },
  mediaAudioTile: {
    width: 72,
    height: 72,
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: "#eef4ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#dbeafe",
    },
  },
  rowMediaIcon: {
    width: 36,
    height: 36,
    borderRadius: 8,
    marginRight: 4,
    border: "1px solid #e6eaf0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
  },
  mediaPlayerDialog: {
    borderRadius: 12,
    maxWidth: 900,
    width: "100%",
    backgroundColor: "#000",
  },
  mediaPlayerVideo: {
    width: "100%",
    maxHeight: "70vh",
    outline: "none",
  },
  progressBox: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  progressLabel: {
    fontSize: "0.8125rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  primaryBtn: {
    backgroundColor: "rgb(15 59 98)",
    color: "#fff",
    "&:hover": {
      backgroundColor: "rgb(12 47 78)",
    },
  },
  studentsDialogPaper: {
    borderRadius: 12,
    maxWidth: 400,
    width: "100%",
  },
  studentsList: {
    maxHeight: 320,
    overflowY: "auto",
    padding: 0,
  },
}));

const getStoredUserDetails = () => {
  try {
    return JSON.parse(localStorage.getItem("userDetail") || "{}");
  } catch {
    return {};
  }
};

const normalizeId = (value) => {
  if (value === undefined || value === null || value === "") return "";
  if (typeof value === "object" && value._id) return String(value._id);
  return String(value);
};

const getSchoolId = (ud) => normalizeId(ud?.schooleId?._id || ud?.schooleId || ud?.schoolId);

const fileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

const mergeSelectedFiles = (existing, incoming) => {
  const keys = new Set(existing.map(fileKey));
  return [...existing, ...incoming.filter((f) => !keys.has(fileKey(f)))];
};

const MAX_MEDIA_AT_A_TIME = 10;
const MAX_VIDEO_AUDIO_SIZE_MB = 50;
const MAX_VIDEO_AUDIO_BYTES = MAX_VIDEO_AUDIO_SIZE_MB * 1024 * 1024;

const formatFileSizeMb = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

const VIDEO_EXT = /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?|$)/i;
const AUDIO_EXT = /\.(mp3|wav|ogg|m4a|aac|flac|mpeg)(\?|$)/i;

const getMediaTypeFromFile = (file) => {
  if (!file) return "image";
  const mime = file.type || "";
  if (mime.startsWith("video/")) return "video";
  if (mime.startsWith("audio/")) return "audio";
  if (mime.startsWith("image/")) return "image";
  const name = (file.name || "").toLowerCase();
  if (VIDEO_EXT.test(name)) return "video";
  if (AUDIO_EXT.test(name)) return "audio";
  return "image";
};

const getOversizedVideoAudioFiles = (files) =>
  (files || []).filter((file) => {
    const type = getMediaTypeFromFile(file);
    return (type === "video" || type === "audio") && file.size > MAX_VIDEO_AUDIO_BYTES;
  });

const filterValidMediaFiles = (files) => {
  const oversized = getOversizedVideoAudioFiles(files);
  if (!oversized.length) return files;
  const names = oversized.map((f) => `${f.name} (${formatFileSizeMb(f.size)})`).join("\n");
  alert(
    `Video and audio files must be ${MAX_VIDEO_AUDIO_SIZE_MB} MB or smaller.\n\nToo large:\n${names}`
  );
  return files.filter((f) => !oversized.includes(f));
};

const getMediaTypeFromUrl = (url) => {
  if (!url || typeof url !== "string") return "image";
  const lower = url.split("?")[0].toLowerCase();
  if (VIDEO_EXT.test(lower)) return "video";
  if (AUDIO_EXT.test(lower)) return "audio";
  return "image";
};

const groupMediaByType = (items, getType) => {
  const groups = { image: [], video: [], audio: [] };
  items.forEach((item, index) => {
    const type = getType(item);
    groups[type].push({ item, index });
  });
  return groups;
};

const getDefaultFormValues = (userDetails) => ({
  eventName: "",
  imageURL: [],
  classId: userDetails?.role === "TEACHER" ? normalizeId(userDetails.classId) : "",
  sectionId: userDetails?.role === "TEACHER" ? normalizeId(userDetails.sectionId) : "",
  date: "",
  studentId: [],
  isEventForAllStudent: false,
  status: "draft",
});

const normalizeImageStoreStatus = (value) =>
  String(value || "draft").toLowerCase() === "published" ? "published" : "draft";

const formatImageStoreStatusLabel = (value) =>
  normalizeImageStoreStatus(value) === "published" ? "Published" : "Draft";

const IMAGE_STORE_STATUS_NOTES = {
  draft:
    "Album is stored in Images Store only; parents and students will not see it on Student Story.",
  published:
    "Album is shared on Student Story for the selected students (or all students in the class/section).",
};

export default function ImagesStore() {
  const classes = useStyles();
  const history = useHistory();
  const userDetails = useMemo(() => getStoredUserDetails(), []);
  const role = userDetails.role || "";
  const defaultSchoolId = getSchoolId(userDetails);

  const goToAddMedia = (row) => {
    if (!row?._id) return;
    history.push(`/app/imagesstore/${row._id}/add-media`);
  };

  const rowHasMedia = (row) =>
    (Array.isArray(row?.imageURL) && row.imageURL.filter(Boolean).length > 0) ||
    (Array.isArray(row?.videoURL) && row.videoURL.filter(Boolean).length > 0);

  const getRowMediaUrls = (row) => {
    const images = Array.isArray(row?.imageURL) ? row.imageURL.filter(Boolean) : [];
    const videos = Array.isArray(row?.videoURL) ? row.videoURL.filter(Boolean) : [];
    const seen = new Set();
    return [...images, ...videos].filter((url) => {
      if (seen.has(url)) return false;
      seen.add(url);
      return true;
    });
  };

  const toggleMediaPreview = (rowId) =>
    setMediaPreview((prev) => ({ ...prev, [rowId]: !prev[rowId] }));

  const renderRowMediaThumb = (row, url, idx, options = {}) => {
    const { large = false } = options;
    const mediaType = getMediaTypeFromUrl(url);
    const tileStyle = large
      ? { width: 96, height: 96, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", border: "1px solid #e6eaf0" }
      : undefined;
    if (mediaType === "video") {
      return (
        <Box
          key={`${row._id}-media-${idx}`}
          className={large ? undefined : classes.rowMediaIcon}
          style={{ backgroundColor: "#0f2d4d", ...(tileStyle || {}) }}
          onClick={() => openMediaPlayer(url, "video", row.eventName)}
          role="button"
          tabIndex={0}
          aria-label="Play video"
        >
          <PlayArrowIcon style={{ color: "#fff", fontSize: large ? 34 : 18 }} />
        </Box>
      );
    }
    if (mediaType === "audio") {
      return (
        <Box
          key={`${row._id}-media-${idx}`}
          className={large ? undefined : classes.rowMediaIcon}
          style={{ backgroundColor: "#eef4ff", ...(tileStyle || {}) }}
          onClick={() => openMediaPlayer(url, "audio", row.eventName)}
          role="button"
          tabIndex={0}
          aria-label="Play audio"
        >
          <AudiotrackIcon style={{ color: "#1769d6", fontSize: large ? 30 : 16 }} />
        </Box>
      );
    }
    return (
      <img
        key={`${row._id}-media-${idx}`}
        src={url}
        alt=""
        className={large ? undefined : classes.rowThumb}
        onClick={() => openMediaPlayer(url, "image", row.eventName)}
        style={large
          ? { width: 96, height: 96, objectFit: "cover", borderRadius: 10, border: "1px solid #e6eaf0", cursor: "pointer" }
          : { cursor: "pointer" }}
      />
    );
  };

  const [list, setList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [superAdminSchoolId, setSuperAdminSchoolId] = useState("");
  const [filterClassId, setFilterClassId] = useState("");
  const [filterSectionId, setFilterSectionId] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterSectionList, setFilterSectionList] = useState([]);
  const [teacherHasMultipleClasses, setTeacherHasMultipleClasses] = useState(false);
  const [teacherCanPickSection, setTeacherCanPickSection] = useState(false);
  const [teacherFiltersReady, setTeacherFiltersReady] = useState(role !== "TEACHER");
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [recordId, setRecordId] = useState("");
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({
    active: false,
    phase: "",
    percent: 0,
    total: 0,
    completed: 0,
    failed: 0,
    currentFileName: "",
    message: "",
  });
  const [pg, setPg] = useState(0);
  const [rpg, setRpg] = useState(10);
  const [mediaPreview, setMediaPreview] = useState({});
  const [noteOpen, setNoteOpen] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
  const [actionMenu, setActionMenu] = useState({ anchor: null, row: null });
  const [visibleCols, setVisibleCols] = useState({
    name: true,
    images: true,
    class: true,
    section: true,
    students: true,
    date: true,
    status: true,
  });
  const [viewStudents, setViewStudents] = useState({
    open: false,
    title: "",
    loading: false,
    isAll: false,
    items: [],
  });
  const [statusUpdatingId, setStatusUpdatingId] = useState("");
  const [statusConfirmDialog, setStatusConfirmDialog] = useState({
    open: false,
    row: null,
    newStatus: "",
  });
  const [mediaPlayer, setMediaPlayer] = useState({ open: false, url: "", type: "image", title: "" });

  const columnConfig = [
    { id: "name", label: "Name" },
    { id: "images", label: "Media" },
    { id: "class", label: "Class" },
    { id: "section", label: "Section" },
    { id: "students", label: "Students" },
    { id: "date", label: "Date" },
    { id: "status", label: "Status" },
  ];
  const openActionMenu = (e, row) => setActionMenu({ anchor: e.currentTarget, row });
  const closeActionMenu = () => setActionMenu({ anchor: null, row: null });

  const effectiveSchoolId = role === "SUPERADMIN" ? superAdminSchoolId : defaultSchoolId;

  const validationSchema = Yup.object().shape({
    eventName: Yup.string().required("Name is required"),
    classId: Yup.string().required("Class is required"),
    date: Yup.string(),
    sectionId: Yup.string(),
    studentId: Yup.array(),
    imageURL: Yup.array(),
    isEventForAllStudent: Yup.boolean(),
    status: Yup.string().oneOf(["draft", "published"], "Select a valid status"),
  });

  const formik = useFormik({
    initialValues: getDefaultFormValues(userDetails),
    validationSchema,
    enableReinitialize: false,
    onSubmit: (values) => {
      if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
        alert("Please select at least one student.");
        return;
      }
      if (isEditMode) {
        updateRecord();
      } else {
        addRecord();
      }
    },
  });

  const applyClientFilters = (rows) => {
    let filtered = Array.isArray(rows) ? rows : [];
    const classFilter = normalizeId(filterClassId);
    const sectionFilter = normalizeId(filterSectionId);

    if (classFilter) {
      filtered = filtered.filter(
        (row) => normalizeId(row.classId?._id || row.classId) === classFilter,
      );
    }
    if (sectionFilter) {
      filtered = filtered.filter(
        (row) => normalizeId(row.sectionId?._id || row.sectionId) === sectionFilter,
      );
    }
    return filtered;
  };

  const loadList = () => {
    if (!effectiveSchoolId) {
      setList([]);
      return;
    }
    if (role === "TEACHER" && !filterClassId) {
      setList([]);
      return;
    }

    const body = { schooleId: effectiveSchoolId };
    const classFilter = normalizeId(filterClassId);
    const sectionFilter = normalizeId(filterSectionId);
    if (classFilter) body.classId = classFilter;
    if (sectionFilter) body.sectionId = sectionFilter;

    ImagesStoreService.findImagesStoreList(body)
      .then((res) => setList(applyClientFilters(res)))
      .catch((err) => {
        console.error(err);
        alert(err?.response?.data?.message || "Failed to load images store");
      });
  };

  const buildSectionListRequest = (classId) => {
    const stored = getStoredUserDetails();
    const body = { classId, schooleId: effectiveSchoolId };
    if (stored.role === "TEACHER" && stored.teacherId) {
      body.teacherId = stored.teacherId;
    }
    return body;
  };

  const loadSections = (classId, target, onLoaded) => {
    if (!classId || !effectiveSchoolId) {
      if (target === "filter") setFilterSectionList([]);
      else setSectionList([]);
      if (role === "TEACHER") setTeacherCanPickSection(false);
      if (onLoaded) onLoaded([]);
      return Promise.resolve([]);
    }
    return SectionService.findSectionList(buildSectionListRequest(classId))
      .then((res) => {
        const rows = Array.isArray(res) ? res : [];
        if (target === "filter") setFilterSectionList(rows);
        else setSectionList(rows);
        if (role === "TEACHER") {
          setTeacherCanPickSection(rows.length > 1);
        }
        if (onLoaded) onLoaded(rows);
        return rows;
      })
      .catch(() => {
        if (target === "filter") setFilterSectionList([]);
        else setSectionList([]);
        if (onLoaded) onLoaded([]);
        return [];
      });
  };

  const applyTeacherClassSection = (classId, preferredSectionId) => {
    const cid = normalizeId(classId);
    const sid = normalizeId(preferredSectionId);
    if (!cid) return Promise.resolve();

    setFilterClassId(cid);
    formik.setFieldValue("classId", cid);

    return loadSections(cid, "filter").then((rows) => {
      loadSections(cid, "form");
      let validSection = "";
      if (rows.length === 1) {
        validSection = normalizeId(rows[0]._id);
      } else if (sid && rows.some((s) => normalizeId(s._id) === sid)) {
        validSection = sid;
      }
      setFilterSectionId(validSection);
      if (!isEditMode) {
        formik.setFieldValue("sectionId", validSection);
      }
      getStudentList(cid, validSection || undefined);
      if (role === "TEACHER") {
        setTeacherFiltersReady(true);
      }
      return { classId: cid, sectionId: validSection, sections: rows };
    });
  };

  const syncTeacherProfile = () => {
    const stored = getStoredUserDetails();
    if (stored.role !== "TEACHER") return Promise.resolve();

    const classId = normalizeId(stored.classId);
    const sectionId = normalizeId(stored.sectionId);

    if (!stored.teacherId) {
      if (classId) return applyTeacherClassSection(classId, sectionId);
      setTeacherFiltersReady(true);
      return Promise.resolve();
    }

    return TeacherService.getTeacherById(stored.teacherId)
      .then((teacher) => {
        const classIds = new Set();
        const primaryClassId = normalizeId(teacher?.classId?._id || teacher?.classId);
        if (primaryClassId) classIds.add(primaryClassId);
        (teacher?.additionalClassAndSection || []).forEach((item) => {
          const cid = normalizeId(item?.class?.classId?._id || item?.class?.classId);
          if (cid) classIds.add(cid);
        });
        setTeacherHasMultipleClasses(classIds.size > 1);

        const freshClassId = primaryClassId || classId;
        const freshSectionId =
          normalizeId(teacher?.sectionId?._id || teacher?.sectionId) || sectionId;
        const updated = {
          ...stored,
          classId: freshClassId,
          sectionId: freshSectionId,
        };
        localStorage.setItem("userDetail", JSON.stringify(updated));
        return applyTeacherClassSection(freshClassId, freshSectionId);
      })
      .catch(() => {
        setTeacherHasMultipleClasses(false);
        if (classId) return applyTeacherClassSection(classId, sectionId);
        setTeacherFiltersReady(true);
        return Promise.resolve();
      });
  };

  const getStudentList = (classIdValue, sectionIdValue) => {
    if (!classIdValue || !effectiveSchoolId) {
      setStudentList([]);
      return;
    }
    const body = { classId: classIdValue };
    if (sectionIdValue) body.sectionId = sectionIdValue;
    StudentService.getAllStudentById(effectiveSchoolId, body)
      .then((res) => {
        const rows = (Array.isArray(res) ? res : []).map((r) => ({
          _id: r._id,
          studentName: `${r.firstName || ""} ${r.lastName || ""}`.trim(),
        }));
        setStudentList(rows);
      })
      .catch(() => setStudentList([]));
  };

  const loadClasses = (schoolId) => {
    if (!schoolId) return Promise.resolve();
    return AddClassService.getAllAddClass(schoolId, role, true)
      .then((res) => {
        const rows = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        setClassList(rows.filter((c) => c._id));
        if (role === "TEACHER") {
          return syncTeacherProfile();
        }
        return Promise.resolve();
      })
      .catch(() => {
        setClassList([]);
        return Promise.resolve();
      });
  };

  useEffect(() => {
    if (role === "SUPERADMIN") {
      SchooleRegistrationService.getAllSchooleRegistration()
        .then((res) => setSchoolList(Array.isArray(res) ? res : []))
        .catch(() => setSchoolList([]));
    }
  }, [role]);

  useEffect(() => {
    if (!effectiveSchoolId) return;
    if (role === "TEACHER") {
      setTeacherFiltersReady(false);
    }
    loadClasses(effectiveSchoolId).then(() => {
      if (role !== "TEACHER") {
        setTeacherFiltersReady(true);
      }
    });
  }, [effectiveSchoolId, role]);

  useEffect(() => {
    if (!effectiveSchoolId || !teacherFiltersReady) return;
    loadList();
  }, [effectiveSchoolId, filterClassId, filterSectionId, teacherFiltersReady]);

  const onFilterClassChange = (e) => {
    const id = normalizeId(e.target.value);
    setFilterClassId(id);
    setFilterSectionId("");
    setPg(0);
    if (id) {
      loadSections(id, "filter").then((rows) => {
        if (rows.length === 1) {
          const onlySection = normalizeId(rows[0]._id);
          setFilterSectionId(onlySection);
          if (!isEditMode) {
            formik.setFieldValue("sectionId", onlySection);
          }
        }
      });
      getStudentList(id, undefined);
    } else {
      setFilterSectionList([]);
      setStudentList([]);
      setList([]);
    }
  };

  const onFilterSectionChange = (e) => {
    const sid = normalizeId(e.target.value);
    setFilterSectionId(sid);
    setPg(0);
    if (!isEditMode) {
      formik.setFieldValue("sectionId", sid);
      formik.setFieldValue("studentId", []);
    }
    if (filterClassId) {
      getStudentList(filterClassId, sid || undefined);
    }
  };

  const handleOpen = (create) => {
    if (create) {
      const stored = getStoredUserDetails();
      const initial = getDefaultFormValues(stored);
      setRecordId("");
      setIsEditMode(false);
      setImages([]);
      formik.resetForm({ values: initial });

      if (stored.role === "TEACHER") {
        syncTeacherProfile().then(({ sectionId, classId } = {}) => {
          formik.setValues({
            ...initial,
            classId: classId || normalizeId(stored.classId),
            sectionId: sectionId || normalizeId(stored.sectionId),
          });
        });
      } else if (initial.classId) {
        loadSections(initial.classId, "form");
        getStudentList(initial.classId, initial.sectionId || undefined);
      }
    }
    setOpen(true);
  };

  const handleClose = () => {
    if (uploading) return;
    setOpen(false);
    setIsEditMode(false);
    clearPendingImages();
    const stored = getStoredUserDetails();
    formik.resetForm({ values: getDefaultFormValues(stored) });
    if (stored.role === "TEACHER") {
      syncTeacherProfile();
    }
  };

  useEffect(() => {
    if (role !== "TEACHER" || !effectiveSchoolId) return undefined;
    const refreshTeacherSectionOptions = () => {
      const cid = normalizeId(filterClassId);
      if (cid) {
        loadSections(cid, "filter");
        return;
      }
      syncTeacherProfile();
    };
    window.addEventListener("focus", refreshTeacherSectionOptions);
    return () => window.removeEventListener("focus", refreshTeacherSectionOptions);
  }, [role, effectiveSchoolId, filterClassId]);

  const pendingPreviews = useMemo(
    () =>
      images.map((file) => ({
        file,
        key: fileKey(file),
        url: URL.createObjectURL(file),
      })),
    [images],
  );

  useEffect(() => {
    return () => {
      pendingPreviews.forEach((p) => URL.revokeObjectURL(p.url));
    };
  }, [pendingPreviews]);

  const openMediaPlayer = (url, type, title = "") => {
    setMediaPlayer({ open: true, url, type, title });
  };

  const closeMediaPlayer = () => {
    setMediaPlayer({ open: false, url: "", type: "image", title: "" });
  };

  const renderMediaPreviewTile = (url, options = {}) => {
    const {
      onRemove,
      removeLabel = "Remove",
      fileName = "",
      size = "large",
      mediaType = getMediaTypeFromUrl(url),
    } = options;
    const isLarge = size === "large";
    const thumbClass = isLarge ? classes.thumbPreview : classes.rowThumb;

    const tileContent = () => {
      if (mediaType === "video") {
        return (
          <Box
            className={isLarge ? classes.mediaPlayTile : classes.rowMediaIcon}
            style={isLarge ? undefined : { backgroundColor: "#0f2d4d" }}
            onClick={() => openMediaPlayer(url, "video", fileName)}
            role="button"
            tabIndex={0}
            aria-label="Play video"
          >
            <PlayArrowIcon className={classes.mediaPlayIcon} style={isLarge ? undefined : { fontSize: 20, color: "#fff" }} />
          </Box>
        );
      }
      if (mediaType === "audio") {
        return (
          <Box
            className={isLarge ? classes.mediaAudioTile : classes.rowMediaIcon}
            style={isLarge ? undefined : { backgroundColor: "#eef4ff" }}
            onClick={() => openMediaPlayer(url, "audio", fileName)}
            role="button"
            tabIndex={0}
            aria-label="Play audio"
          >
            <AudiotrackIcon style={{ color: "#1769d6", fontSize: isLarge ? 32 : 18 }} />
          </Box>
        );
      }
      return (
        <img
          src={url}
          alt={fileName || ""}
          className={thumbClass}
          onClick={isLarge ? () => openMediaPlayer(url, "image", fileName) : undefined}
          style={isLarge ? { cursor: "pointer" } : undefined}
        />
      );
    };

    return (
      <Box key={url} className={classes.previewItem}>
        {tileContent()}
        {fileName && isLarge ? (
          <Typography className={classes.pendingFileName} title={fileName}>
            {fileName}
          </Typography>
        ) : null}
        {onRemove ? (
          <IconButton
            size="small"
            className={classes.removeThumbBtn}
            onClick={onRemove}
            aria-label={removeLabel}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        ) : null}
      </Box>
    );
  };

  const renderPendingFileTile = (file, idx, previewUrl) => {
    const mediaType = getMediaTypeFromFile(file);
    const key = fileKey(file);

    const previewBody = () => {
      if (mediaType === "video") {
        return (
          <Box className={classes.mediaPlayTile} title={file.name}>
            <VideocamIcon className={classes.mediaPlayIcon} style={{ fontSize: 28 }} />
            <PlayArrowIcon
              style={{
                position: "absolute",
                color: "#fff",
                fontSize: 24,
                bottom: 8,
                right: 8,
                opacity: 0.9,
              }}
            />
          </Box>
        );
      }
      if (mediaType === "audio") {
        return (
          <Box className={classes.mediaAudioTile} title={file.name}>
            <AudiotrackIcon style={{ color: "#1769d6", fontSize: 32 }} />
          </Box>
        );
      }
      return <img src={previewUrl} alt={file.name} className={classes.thumbPreview} />;
    };

    return (
      <Box key={key} className={classes.previewItem}>
        {previewBody()}
        <Typography className={classes.pendingFileName} title={file.name}>
          {file.name}
        </Typography>
        <IconButton
          size="small"
          className={classes.removeThumbBtn}
          onClick={() => removePendingImageAt(idx)}
          aria-label={`Remove ${file.name}`}
          disabled={uploading}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  };

  const renderUploadedMediaSection = (urls, onRemoveAt) => {
    const grouped = groupMediaByType(urls, getMediaTypeFromUrl);
    const sections = [
      { key: "image", label: "Images", items: grouped.image },
      { key: "video", label: "Videos", items: grouped.video },
      { key: "audio", label: "Audio", items: grouped.audio },
    ].filter((s) => s.items.length > 0);

    if (!sections.length) return null;

    return sections.map((section) => (
      <Box key={section.key} style={{ width: "100%" }}>
        <Typography className={classes.mediaTypeLabel}>
          {section.label} ({section.items.length})
        </Typography>
        <Box className={classes.previewGrid}>
          {section.items.map(({ item: url, index: idx }) =>
            renderMediaPreviewTile(url, {
              onRemove: () => onRemoveAt(idx),
              removeLabel: `Remove ${section.key}`,
              size: "large",
              mediaType: section.key,
            })
          )}
        </Box>
      </Box>
    ));
  };

  const handleFileChange = (e) => {
    const picked = filterValidMediaFiles(Array.from(e.target.files || []));
    if (!picked.length) {
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    if (picked.length > MAX_MEDIA_AT_A_TIME) {
      alert(`You can select at most ${MAX_MEDIA_AT_A_TIME} files at a time.`);
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    setImages((prev) => {
      const merged = mergeSelectedFiles(prev, picked);
      if (merged.length > MAX_MEDIA_AT_A_TIME) {
        alert(
          `You can upload at most ${MAX_MEDIA_AT_A_TIME} files at a time. Remove some files or upload the current selection first.`
        );
        return prev;
      }
      return merged;
    });
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const removePendingImageAt = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const clearPendingImages = () => {
    setImages([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const pollUploadProgress = (uploadId) =>
    new Promise((resolve, reject) => {
      const poll = async () => {
        try {
          const progress = await ImagesStoreService.getUploadProgress(uploadId);
          setUploadProgress({
            active: true,
            phase: "azure",
            percent: progress.percent || 0,
            total: progress.total || 0,
            completed: progress.completed || 0,
            failed: progress.failed || 0,
            currentFileName: progress.currentFileName || "",
            message: progress.message || "",
          });
          if (progress.status === "done") {
            resolve(progress);
            return;
          }
          if (progress.status === "failed") {
            reject(new Error(progress.message || "Upload failed"));
            return;
          }
          setTimeout(poll, 450);
        } catch (err) {
          reject(err);
        }
      };
      poll();
    });

const UPLOAD_BATCH_SIZE = 50;

  const uploadBatch = async (batchFiles, batchIndex, batchCount) => {
    const formData = new FormData();
    batchFiles.forEach((file) => {
      formData.append("images", file);
    });
    if (role === "SUPERADMIN" && effectiveSchoolId) {
      formData.append("schooleId", effectiveSchoolId);
    }

    const batchLabel =
      batchCount > 1 ? ` (batch ${batchIndex + 1} of ${batchCount})` : "";

    setUploadProgress((prev) => ({
      ...prev,
      active: true,
      phase: "sending",
      message: `Sending ${batchFiles.length} file(s) to server${batchLabel}…`,
    }));

    const startRes = await ImagesStoreService.uploadImagesBatch(formData, (sendProg) => {
      setUploadProgress((prev) => ({
        ...prev,
        active: true,
        phase: "sending",
        percent: sendProg.percent,
        message: `Sending to server${batchLabel}: ${sendProg.percent}%`,
      }));
    });

    if (!startRes?.uploadId) {
      throw new Error("Upload did not return a session id.");
    }

    setUploadProgress((prev) => ({
      ...prev,
      phase: "azure",
      percent: 0,
      message: `Uploading to Azure${batchLabel} (0 / ${startRes.total || batchFiles.length})…`,
    }));

    const finalProgress = await pollUploadProgress(startRes.uploadId);
    return Array.isArray(finalProgress?.urls)
      ? finalProgress.urls
      : (Array.isArray(finalProgress?.files) ? finalProgress.files.map((f) => f.url) : []);
  };

  const handleUpload = async () => {
    if (!images.length) {
      alert("Please select files first.");
      return;
    }

    if (images.length > MAX_MEDIA_AT_A_TIME) {
      alert(`You can upload at most ${MAX_MEDIA_AT_A_TIME} files at a time.`);
      return;
    }

    const oversized = getOversizedVideoAudioFiles(images);
    if (oversized.length) {
      const names = oversized.map((f) => `${f.name} (${formatFileSizeMb(f.size)})`).join("\n");
      alert(
        `Video and audio files must be ${MAX_VIDEO_AUDIO_SIZE_MB} MB or smaller.\n\nToo large:\n${names}`
      );
      return;
    }

    setUploading(true);
    setUploadProgress({
      active: true,
      phase: "sending",
      percent: 0,
      total: images.length,
      completed: 0,
      failed: 0,
      currentFileName: "",
      message: "Preparing upload…",
    });

    const totalFiles = images.length;
    const batches = [];
    for (let i = 0; i < images.length; i += UPLOAD_BATCH_SIZE) {
      batches.push(images.slice(i, i + UPLOAD_BATCH_SIZE));
    }

    setUploadProgress({
      active: true,
      phase: "sending",
      percent: 0,
      total: totalFiles,
      completed: 0,
      failed: 0,
      currentFileName: "",
      message: `Sending ${totalFiles} file(s) to server…`,
    });
    try {
      const allUploaded = [];
      for (let i = 0; i < batches.length; i += 1) {
        const batchUrls = await uploadBatch(batches[i], i, batches.length);
        if (!batchUrls.length) {
          throw new Error(`Batch ${i + 1} did not upload any images.`);
        }
        allUploaded.push(...batchUrls);
        setUploadProgress((prev) => ({
          ...prev,
          completed: allUploaded.length,
          percent: Math.round((allUploaded.length / totalFiles) * 100),
          message: `Uploaded ${allUploaded.length} of ${totalFiles} file(s)…`,
        }));
      }

      const merged = [...(formik.values.imageURL || []), ...allUploaded];
      formik.setFieldValue("imageURL", merged);
      clearPendingImages();
      alert(`Uploaded ${allUploaded.length} of ${totalFiles} file(s) successfully.`);
    } catch (err) {
      alert(err?.response?.data?.message || err?.message || "Upload failed");
    } finally {
      setUploading(false);
      setUploadProgress({
        active: false,
        phase: "",
        percent: 0,
        total: 0,
        completed: 0,
        failed: 0,
        currentFileName: "",
        message: "",
      });
    }
  };

  const removeImageAt = (index) => {
    const url = formik.values.imageURL[index];
    const next = formik.values.imageURL.filter((_, i) => i !== index);
    formik.setFieldValue("imageURL", next);
    if (url && !url.startsWith("data:")) {
      ImagesStoreService.deleteAzureImage({ imageURL: url }).catch(() => {});
    }
  };

  const buildPayload = () => ({
    eventName: formik.values.eventName,
    imageURL: (formik.values.imageURL || []).filter(Boolean),
    classId: formik.values.classId,
    sectionId: formik.values.sectionId || null,
    date: formik.values.date || "",
    studentId: formik.values.isEventForAllStudent ? [] : formik.values.studentId || [],
    isEventForAllStudent: !!formik.values.isEventForAllStudent,
    status: normalizeImageStoreStatus(formik.values.status),
    schooleId: effectiveSchoolId,
  });

  const addRecord = async () => {
    try {
      await ImagesStoreService.createImagesStore(buildPayload());
      alert("saved successfully!");
      handleClose();
      loadList();
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to save");
    }
  };

  const editRecord = (row) => {
    setRecordId(row._id);
    setIsEditMode(true);
    const classId = normalizeId(row.classId?._id || row.classId);
    const sectionId = normalizeId(row.sectionId?._id || row.sectionId);
    const studentIds = Array.isArray(row.studentId)
      ? row.studentId.map((s) => (typeof s === "object" && s?._id ? s._id : s))
      : [];

    formik.setValues({
      eventName: row.eventName || "",
      imageURL: row.imageURL || [],
      classId,
      sectionId,
      date: row.date || "",
      studentId: studentIds,
      isEventForAllStudent: !!row.isEventForAllStudent,
      status: normalizeImageStoreStatus(row.status),
    });
    if (classId) {
      loadSections(classId, "form", () => {
        formik.setFieldValue("sectionId", sectionId);
        getStudentList(classId, sectionId || undefined);
      });
    }
    setOpen(true);
  };

  const updateRecord = async () => {
    try {
      await ImagesStoreService.updateImagesStore(recordId, buildPayload());
      alert("Images Store updated successfully!");
      handleClose();
      loadList();
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to update");
    }
  };

  const deleteRecord = (row) => {
    if (!window.confirm("Delete this images store record?")) return;
    ImagesStoreService.deleteImagesStore(row._id)
      .then(() => {
        alert("Deleted successfully!");
        loadList();
      })
      .catch((err) => alert(err?.response?.data?.message || "Delete failed"));
  };

  const handleInlineStatusChange = (row, newStatus) => {
    const normalized = normalizeImageStoreStatus(newStatus);
    if (!row?._id || normalizeImageStoreStatus(row.status) === normalized) return;

    setStatusConfirmDialog({
      open: true,
      row,
      newStatus: normalized,
    });
  };

  const closeStatusConfirmDialog = () => {
    setStatusConfirmDialog({ open: false, row: null, newStatus: "" });
  };

  const confirmInlineStatusChange = async () => {
    const { row, newStatus } = statusConfirmDialog;
    if (!row?._id || !newStatus) {
      closeStatusConfirmDialog();
      return;
    }

    const normalized = normalizeImageStoreStatus(newStatus);
    const previousStatus = normalizeImageStoreStatus(row.status);
    closeStatusConfirmDialog();
    setStatusUpdatingId(row._id);
    setList((prev) =>
      prev.map((item) => (item._id === row._id ? { ...item, status: normalized } : item))
    );

    try {
      await ImagesStoreService.updateImagesStore(row._id, { status: normalized });
    } catch (err) {
      setList((prev) =>
        prev.map((item) =>
          item._id === row._id ? { ...item, status: previousStatus } : item
        )
      );
      alert(err?.response?.data?.message || "Failed to update status");
    } finally {
      setStatusUpdatingId("");
    }
  };

  const classLabel = (row) => row.classId?.className || row.classId || "—";
  const sectionLabel = (row) => row.sectionId?.sectionName || row.sectionId || "—";
  const formatStudentName = (s) => {
    if (!s) return "";
    if (typeof s === "string") return s;
    const name = `${s.firstName || ""} ${s.lastName || ""}`.trim();
    return name || s.studentName || "";
  };

  const studentLabel = (row) => {
    if (row.isEventForAllStudent) return "All students";
    const students = Array.isArray(row.studentId) ? row.studentId : [];
    if (!students.length) return "—";
    const names = students.map(formatStudentName).filter(Boolean);
    if (names.length <= 2) return names.join(", ");
    return `${names.slice(0, 2).join(", ")} +${names.length - 2} more`;
  };

  const isColumnVisible = (columnId) => visibleCols[columnId] !== false;

  const visibleDataColumns = columnConfig.filter((c) => isColumnVisible(c.id));

  const renderTableCell = (row, columnId) => {
    switch (columnId) {
      case "name":
        return (
          <Typography
            component="span"
            style={{ fontWeight: 600, color: "#0f2d4d", whiteSpace: "nowrap" }}
          >
            {row.eventName}
          </Typography>
        );
      case "images": {
        const mediaUrls = getRowMediaUrls(row);
        if (mediaUrls.length === 0) {
          return <Typography variant="caption" style={{ color: "#9aa6b6" }}>No media</Typography>;
        }
        const isPreviewOpen = !!mediaPreview[row._id];
        return (
          <Tooltip title={isPreviewOpen ? "Hide media" : "Show media"}>
            <IconButton
              size="small"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                toggleMediaPreview(row._id);
              }}
              aria-label={isPreviewOpen ? "Hide media" : "Show media"}
            >
              {isPreviewOpen ? (
                <VisibilityOffIcon fontSize="small" />
              ) : (
                <VisibilityIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        );
      }
      case "class":
        return <Chip size="small" label={classLabel(row)} className={classes.classChip} />;
      case "section":
        return <Chip size="small" label={sectionLabel(row)} className={classes.sectionChip} />;
      case "students":
        return <Chip size="small" label={studentLabel(row)} className={classes.studentChip} />;
      case "date":
        return (
          <Box
            display="flex"
            alignItems="center"
            gridGap={6}
            style={{ color: "#46566b", whiteSpace: "nowrap" }}
          >
            <EventIcon style={{ fontSize: 16, color: "#9aa6b6" }} />
            {row.date || "—"}
          </Box>
        );
      case "status": {
        const currentStatus = normalizeImageStoreStatus(row.status);
        const isUpdating = statusUpdatingId === row._id;
        return (
          <Box
            display="flex"
            alignItems="center"
            gridGap={6}
            onClick={(e) => e.stopPropagation()}
          >
            <FormControl
              size="small"
              variant="outlined"
              disabled={isUpdating}
              className={`${classes.statusSelect} ${
                currentStatus === "published"
                  ? classes.statusSelectPublished
                  : classes.statusSelectDraft
              }`}
            >
              <Select
                value={currentStatus}
                onChange={(e) => handleInlineStatusChange(row, e.target.value)}
                renderValue={(value) => formatImageStoreStatusLabel(value)}
              >
                <MenuItem value="draft">Draft</MenuItem>
                <MenuItem value="published">Published</MenuItem>
              </Select>
            </FormControl>
            {isUpdating ? <CircularProgress size={16} /> : null}
          </Box>
        );
      }
      default:
        return null;
    }
  };

  const closeViewStudents = () => {
    setViewStudents({ open: false, title: "", loading: false, isAll: false, items: [] });
  };

  const openViewStudents = async (row) => {
    const classId = normalizeId(row.classId?._id || row.classId);
    const sectionId = normalizeId(row.sectionId?._id || row.sectionId);
    setViewStudents({
      open: true,
      title: row.eventName || "Students",
      loading: true,
      isAll: !!row.isEventForAllStudent,
      items: [],
    });
    try {
      let items = [];
      if (row.isEventForAllStudent) {
        if (classId && effectiveSchoolId) {
          const body = { classId };
          if (sectionId) body.sectionId = sectionId;
          const res = await StudentService.getAllStudentById(effectiveSchoolId, body);
          items = (Array.isArray(res) ? res : []).map((s) => ({
            _id: s._id,
            name: formatStudentName(s) || "—",
          }));
        }
      } else {
        const raw = Array.isArray(row.studentId) ? row.studentId : [];
        items = raw.map((s, idx) => ({
          _id: typeof s === "object" && s?._id ? s._id : `student-${idx}`,
          name: formatStudentName(s) || "—",
        }));
      }
      setViewStudents((prev) => ({ ...prev, loading: false, items }));
    } catch (err) {
      console.error(err);
      setViewStudents((prev) => ({ ...prev, loading: false, items: [] }));
      alert(err?.response?.data?.message || "Could not load students");
    }
  };

  const isTeacher = role === "TEACHER";

  const activeFilterCount =
    (role === "SUPERADMIN" && superAdminSchoolId ? 1 : 0) +
    (filterClassId ? 1 : 0) +
    (filterSectionId ? 1 : 0) +
    (filterStatus ? 1 : 0);

  const handleResetFilters = () => {
    if (isTeacher) return;
    setFilterClassId("");
    setFilterSectionId("");
    setFilterStatus("");
    setFilterSectionList([]);
    setStudentList([]);
    setPg(0);
  };

  const filteredList = list.filter((row) => {
    if (filterStatus && normalizeImageStoreStatus(row.status) !== filterStatus) {
      return false;
    }
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    return (
      (row.eventName || "").toLowerCase().includes(term) ||
      String(classLabel(row)).toLowerCase().includes(term) ||
      studentLabel(row).toLowerCase().includes(term) ||
      formatImageStoreStatusLabel(row.status).toLowerCase().includes(term)
    );
  });

  const visibleColCount = visibleDataColumns.length + 1; // data columns + Actions

  return (
    <Box p={{ xs: 1, sm: 2 }}>
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Images Store</Typography>
          <Typography className={classes.pageSubtitle}>
            Upload and organize event photos, videos, and audio by class, section, and students.
          </Typography>
        </Box>
        <Button
          variant="contained"
          className={classes.addBtn}
          startIcon={<AddIcon />}
          onClick={() => handleOpen(true)}
          disabled={!effectiveSchoolId}
        >
          Add Images 
        </Button>
      </Box>

      {noteOpen && (
        <Box className={classes.noteBanner}>
          <Box className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </Box>
          <Box flex={1}>
            <Typography style={{ fontWeight: 600, color: "#1f3a5f", fontSize: "0.9rem" }}>
              Manage image collections
            </Typography>
            <Typography style={{ color: "#46566b", fontSize: "0.85rem", marginTop: 2 }}>
              Filter by class and section, view the tagged students, and use the actions menu to edit or delete a record.
            </Typography>
            <Typography style={{ color: "#46566b", fontSize: "0.85rem", marginTop: 8 }}>
              <strong>Draft</strong> — Album is stored in Images Store only; parents and students will not see it on Student Story.
            </Typography>
            <Typography style={{ color: "#46566b", fontSize: "0.85rem", marginTop: 4 }}>
              <strong>Published</strong> — Album is shared on Student Story for the selected students (or all students in the class/section).
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)}>
            <CloseIcon style={{ fontSize: 18, color: "#7a8aa0" }} />
          </IconButton>
        </Box>
      )}

      <Card elevation={0} className={classes.filtersCard}>
        <Box className={classes.filtersTopRow}>
          <span className={classes.filtersChip} onClick={() => setFiltersOpen((v) => !v)}>
            <FilterListIcon style={{ fontSize: 18 }} />
            Filters
            {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
            {filtersOpen ? <ExpandMoreIcon style={{ fontSize: 18 }} /> : <ChevronRightIcon style={{ fontSize: 18 }} />}
          </span>
        </Box>

        <Collapse in={filtersOpen}>
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            {role === "SUPERADMIN" && (
              <Grid item xs={12} sm={6} md={4}>
                <Typography className={classes.fieldLabel}>
                  <BusinessIcon style={{ fontSize: 16 }} /> School
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    value={superAdminSchoolId}
                    onChange={(e) => {
                      setSuperAdminSchoolId(e.target.value);
                      setFilterClassId(isTeacher ? String(userDetails.classId || "") : "");
                      setFilterSectionId(isTeacher ? String(userDetails.sectionId || "") : "");
                    }}
                  >
                    <MenuItem value=""><em>Select school</em></MenuItem>
                    {schoolList.map((s) => (
                      <MenuItem key={s._id} value={s._id}>
                        {s.orgName || s.schoolName || s.schooleName || s._id}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Class
              </Typography>
              <FormControl fullWidth variant="outlined" size="small">
                <Select
                  displayEmpty
                  value={filterClassId || ""}
                  onChange={onFilterClassChange}
                  disabled={isTeacher && !teacherHasMultipleClasses}
                >
                  {!isTeacher && <MenuItem value=""><em>All Classes</em></MenuItem>}
                  {classList.map((c) => (
                    <MenuItem key={c._id} value={String(c._id)}>{c.className}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Section
              </Typography>
              <FormControl fullWidth variant="outlined" size="small" disabled={!filterClassId}>
                <Select
                  displayEmpty
                  value={filterSectionId || ""}
                  onChange={onFilterSectionChange}
                  disabled={!filterClassId || (isTeacher && !teacherCanPickSection)}
                >
                  <MenuItem value=""><em>All Sections</em></MenuItem>
                  {filterSectionList.map((s) => (
                    <MenuItem key={s._id} value={String(s._id)}>{s.sectionName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography className={classes.fieldLabel}>Status</Typography>
              <FormControl fullWidth variant="outlined" size="small">
                <Select
                  displayEmpty
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setPg(0);
                  }}
                >
                  <MenuItem value=""><em>All statuses</em></MenuItem>
                  <MenuItem value="draft">Draft</MenuItem>
                  <MenuItem value="published">Published</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {!isTeacher && (
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                Reset
              </Button>
            </Box>
          )}
        </Collapse>
      </Card>

      <Card elevation={0} className={classes.tableCard}>
        {!effectiveSchoolId ? (
          <Typography color="error" style={{ padding: 24 }}>
            Select a school to manage images store.
          </Typography>
        ) : (
          <>
            <Box className={classes.toolbar}>
              <Typography style={{ fontWeight: 700, color: "#0f2d4d" }}>
                {filteredList.length} Record{filteredList.length !== 1 ? "s" : ""}
              </Typography>
              <Box display="flex" alignItems="center" gridGap={10}>
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search records..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ fontSize: 18, color: "#9aa6b6" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Tooltip title="Columns">
                  <IconButton className={classes.iconBtnOutlined} size="small" onClick={(e) => setColumnMenuAnchor(e.currentTarget)}>
                    <ViewColumnIcon style={{ fontSize: 20, color: "#46566b" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Refresh">
                  <IconButton className={classes.iconBtnOutlined} size="small" onClick={loadList}>
                    <RefreshIcon style={{ fontSize: 20, color: "#46566b" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {visibleDataColumns.map((c) => (
                      <TableCell key={c.id} className={classes.headCell}>{c.label}</TableCell>
                    ))}
                    <TableCell className={classes.headCell} align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredList.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={visibleColCount} align="center" style={{ padding: 32, color: "#7a8aa0" }}>
                        No records found.
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredList.slice(pg * rpg, pg * rpg + rpg).map((row) => (
                      <React.Fragment key={row._id}>
                      <TableRow hover>
                        {visibleDataColumns.map((c) => (
                          <TableCell key={`${row._id}-${c.id}`} style={{ verticalAlign: "top" }}>
                            {renderTableCell(row, c.id)}
                          </TableCell>
                        ))}
                        <TableCell align="right" style={{ whiteSpace: "nowrap", verticalAlign: "top" }}>
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={
                              rowHasMedia(row)
                                ? <EditIcon style={{ fontSize: 18 }} />
                                : <PermMediaIcon style={{ fontSize: 18 }} />
                            }
                            onClick={() => goToAddMedia(row)}
                            style={{ textTransform: "none", marginRight: 8 }}
                          >
                            {rowHasMedia(row) ? "Edit Media" : "Add Media"}
                          </Button>
                          <Tooltip title="View students">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => openViewStudents(row)}
                              aria-label="View students"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <IconButton
                            size="small"
                            onClick={(e) => openActionMenu(e, row)}
                            aria-label="More actions"
                          >
                            <MoreVertIcon style={{ fontSize: 20, color: "#46566b" }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      {rowHasMedia(row) ? (
                        <TableRow>
                          <TableCell
                            colSpan={visibleColCount}
                            style={{ paddingTop: 0, paddingBottom: 0, borderBottom: mediaPreview[row._id] ? undefined : "none" }}
                          >
                            <Collapse in={!!mediaPreview[row._id]} timeout="auto" unmountOnExit>
                              <Box
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 8,
                                  padding: "12px 4px",
                                }}
                              >
                                {getRowMediaUrls(row).map((url, idx) =>
                                  renderRowMediaThumb(row, url, idx, { large: true })
                                )}
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      ) : null}
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredList.length}
              page={pg}
              onPageChange={(_, p) => setPg(p)}
              rowsPerPage={rpg}
              onRowsPerPageChange={(e) => {
                setRpg(parseInt(e.target.value, 10));
                setPg(0);
              }}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </>
        )}
      </Card>

      <Menu
        anchorEl={columnMenuAnchor}
        open={Boolean(columnMenuAnchor)}
        onClose={() => setColumnMenuAnchor(null)}
      >
        {columnConfig.map((c) => (
          <MenuItem
            key={c.id}
            onClick={() => setVisibleCols((prev) => ({ ...prev, [c.id]: !isColumnVisible(c.id) }))}
          >
            <Checkbox checked={isColumnVisible(c.id)} size="small" color="primary" />
            {c.label}
          </MenuItem>
        ))}
      </Menu>

      <Menu
        anchorEl={actionMenu.anchor}
        open={Boolean(actionMenu.anchor)}
        onClose={closeActionMenu}
      >
        <MenuItem
          onClick={() => {
            editRecord(actionMenu.row);
            closeActionMenu();
          }}
        >
          <EditIcon style={{ fontSize: 18, marginRight: 8, color: "#1769d6" }} /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            deleteRecord(actionMenu.row);
            closeActionMenu();
          }}
        >
          <DeleteIcon style={{ fontSize: 18, marginRight: 8, color: "#e53935" }} /> Delete
        </MenuItem>
      </Menu>

      <Dialog
        open={viewStudents.open}
        onClose={closeViewStudents}
        maxWidth={false}
        PaperProps={{ className: classes.studentsDialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          Students — {viewStudents.title}
        </DialogTitle>
        <Divider />
        <DialogContent className={classes.dialogContent}>
          {viewStudents.isAll && (
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
              All students in {viewStudents.items.length ? "this class/section" : "class/section"}
            </Typography>
          )}
          {viewStudents.loading ? (
            <Box display="flex" justifyContent="center" py={3}>
              <CircularProgress size={28} />
            </Box>
          ) : viewStudents.items.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              No students found for this record.
            </Typography>
          ) : (
            <List dense className={classes.studentsList}>
              {viewStudents.items.map((student, index) => (
                <ListItem key={student._id || index} divider={index < viewStudents.items.length - 1}>
                  <ListItemText
                    primary={`${index + 1}. ${student.name}`}
                  />
                </ListItem>
              ))}
            </List>
          )}
          {!viewStudents.loading && viewStudents.items.length > 0 && (
            <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 8 }}>
              Total: {viewStudents.items.length} student{viewStudents.items.length !== 1 ? "s" : ""}
            </Typography>
          )}
        </DialogContent>
        <Divider />
        <DialogActions className={classes.dialogActions}>
          <Button onClick={closeViewStudents} color="default">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={uploading ? undefined : handleClose}
        maxWidth={false}
        scroll="paper"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <DialogTitle className={classes.dialogTitle}>
          {isEditMode ? "Edit Images " : "Add Images "}
        </DialogTitle>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Box className={classes.formSection}>
              <Typography className={classes.sectionLabel}>Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name"
                    name="eventName"
                    variant="outlined"
                    size="small"
                    value={formik.values.eventName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                    helperText={formik.touched.eventName && formik.errors.eventName}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Date"
                    name="date"
                    type="date"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.date}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel id="images-store-status-label">Status</InputLabel>
                    <Select
                      labelId="images-store-status-label"
                      label="Status"
                      name="status"
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.status && Boolean(formik.errors.status)}
                    >
                      <MenuItem value="draft">Draft</MenuItem>
                      <MenuItem value="published">Published</MenuItem>
                    </Select>
                  </FormControl>
                  {formik.touched.status && formik.errors.status ? (
                    <Typography variant="caption" color="error" style={{ marginTop: 4, display: "block" }}>
                      {formik.errors.status}
                    </Typography>
                  ) : null}
                  {/* <Box className={classes.statusNoteBox}>
                    <Typography className={classes.statusNoteTitle}>What does status mean?</Typography>
                    <Typography className={classes.statusNoteText}>
                      <strong>Draft:</strong> {IMAGE_STORE_STATUS_NOTES.draft}
                    </Typography>
                    <Typography className={classes.statusNoteText} style={{ marginTop: 6 }}>
                      <strong>Published:</strong> {IMAGE_STORE_STATUS_NOTES.published}
                    </Typography>
                    <Typography className={classes.statusNoteText} style={{ marginTop: 8, color: "#1769d6" }}>
                      Selected: {IMAGE_STORE_STATUS_NOTES[normalizeImageStoreStatus(formik.values.status)]}
                    </Typography>
                  </Box> */}
                </Grid>
              </Grid>
            </Box>

            <Box className={classes.formSection}>
              <Typography className={classes.sectionLabel}>Class &amp; students</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <InputLabel>Select Class</InputLabel>
                    <Select
                      label="Select Class"
                      name="classId"
                      value={formik.values.classId}
                      disabled={isTeacher && !teacherHasMultipleClasses}
                      onChange={(e) => {
                        formik.setFieldValue("sectionId", "");
                        formik.setFieldValue("studentId", []);
                        formik.handleChange(e);
                        loadSections(e.target.value, "form");
                        getStudentList(e.target.value, undefined);
                      }}
                      error={formik.touched.classId && Boolean(formik.errors.classId)}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {classList.map((c) => (
                        <MenuItem key={c._id} value={c._id}>
                          {c.className}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    size="small"
                    disabled={sectionList.length === 0}
                  >
                    <InputLabel>Select Section</InputLabel>
                    <Select
                      label="Select Section"
                      name="sectionId"
                      value={formik.values.sectionId || ""}
                      disabled={isTeacher && !teacherCanPickSection}
                      onChange={(e) => {
                        formik.setFieldValue("studentId", []);
                        formik.handleChange(e);
                        getStudentList(formik.values.classId, e.target.value || undefined);
                      }}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {sectionList.map((s) => (
                        <MenuItem key={s._id} value={s._id}>
                          {s.sectionName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    className={classes.checkboxRow}
                    control={
                      <Checkbox
                        name="isEventForAllStudent"
                        checked={formik.values.isEventForAllStudent}
                        onChange={(e) => {
                          formik.handleChange(e);
                          if (e.target.checked) {
                            formik.setFieldValue("studentId", []);
                          }
                        }}
                        color="primary"
                      />
                    }
                    label="For all class students"
                  />
                </Grid>
                {!formik.values.isEventForAllStudent && (
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      size="small"
                      disabled={!formik.values.classId}
                    >
                      <InputLabel id="studentName-label">Student name</InputLabel>
                      <Select
                        labelId="studentName-label"
                        label="Student name"
                        name="studentId"
                        multiple
                        value={formik.values.studentId}
                        onChange={formik.handleChange}
                        renderValue={(selected) =>
                          studentList
                            .filter(({ _id }) => selected.includes(_id))
                            .map(({ studentName }) => studentName)
                            .join(", ") || "Select students"
                        }
                      >
                        {studentList.map(({ _id, studentName }) => (
                          <MenuItem key={_id} value={_id}>
                            {studentName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* <Box className={classes.formSection}>
              <Typography className={classes.sectionLabel}>Photos, videos &amp; audio</Typography>
              <Box className={classes.imagesPanel}>
                <input
                  ref={fileInputRef}
                  accept="image/*,video/*,audio/*,.mp3,.mp4,.wav,.webm,.mov,.m4a,.aac"
                  style={{ display: "none" }}
                  id="images-store-upload"
                  type="file"
                  multiple
                  onChange={handleFileChange}
                />
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                  Upload images, videos, or MP3/audio files — up to {MAX_MEDIA_AT_A_TIME} at a time. Video and audio files must be {MAX_VIDEO_AUDIO_SIZE_MB} MB or smaller.
                </Typography>
                <Box className={classes.uploadActions}>
                  <label htmlFor="images-store-upload">
                    <Button variant="outlined" component="span" disabled={uploading} size="small">
                      {images.length > 0 ? "Add more files" : "Select files"}
                    </Button>
                  </label>
                  {images.length > 0 && (
                    <>
                      <Button
                        variant="contained"
                        className={classes.primaryBtn}
                        onClick={handleUpload}
                        disabled={uploading}
                        size="small"
                        startIcon={uploading ? <CircularProgress size={16} color="inherit" /> : null}
                      >
                        {uploading
                          ? "Uploading…"
                          : `Upload ${images.length} file${images.length === 1 ? "" : "s"}`}
                      </Button>
                      <Button
                        variant="text"
                        size="small"
                        disabled={uploading}
                        onClick={clearPendingImages}
                      >
                        Clear selection
                      </Button>
                    </>
                  )}
                </Box>
                {images.length > 0 && !uploading ? (
                  <Box className={classes.pendingPanel}>
                    <Typography className={classes.pendingLabel}>
                      {images.length} file{images.length === 1 ? "" : "s"} ready to upload
                    </Typography>
                    {(() => {
                      const grouped = groupMediaByType(images, getMediaTypeFromFile);
                      const sections = [
                        { key: "image", label: "Images", items: grouped.image },
                        { key: "video", label: "Videos", items: grouped.video },
                        { key: "audio", label: "Audio", items: grouped.audio },
                      ].filter((s) => s.items.length > 0);
                      return sections.map((section) => (
                        <Box key={section.key}>
                          <Typography className={classes.mediaTypeLabel}>
                            {section.label} ({section.items.length})
                          </Typography>
                          <Box className={classes.previewGrid}>
                            {section.items.map(({ item: file, index: idx }) => {
                              const preview = pendingPreviews.find((p) => p.key === fileKey(file));
                              return renderPendingFileTile(file, idx, preview?.url);
                            })}
                          </Box>
                        </Box>
                      ));
                    })()}
                  </Box>
                ) : null}
                {uploading && (
                  <Box className={classes.uploadOverlay}>
                    <CircularProgress size={48} thickness={4} style={{ color: "#1769d6" }} />
                    <Typography className={classes.uploadOverlayTitle}>
                      Uploading files…
                    </Typography>
                    <Typography variant="body2" color="textSecondary" align="center">
                      {uploadProgress.active
                        ? uploadProgress.phase === "sending"
                          ? uploadProgress.message
                          : `${uploadProgress.message}${uploadProgress.currentFileName ? ` — ${uploadProgress.currentFileName}` : ""}`
                        : "Preparing upload…"}
                    </Typography>
                    <Box className={classes.uploadOverlayProgress}>
                      <LinearProgress
                        variant={uploadProgress.percent > 0 ? "determinate" : "indeterminate"}
                        value={uploadProgress.percent}
                        style={{ height: 8, borderRadius: 4 }}
                      />
                    </Box>
                    <Typography variant="caption" color="textSecondary" align="center">
                      {uploadProgress.phase === "azure" && uploadProgress.total > 0
                        ? `${uploadProgress.completed} / ${uploadProgress.total} uploaded (${uploadProgress.percent}%)`
                        : uploadProgress.percent > 0
                        ? `${uploadProgress.percent}%`
                        : "Please wait…"}
                      {uploadProgress.failed > 0 ? ` · ${uploadProgress.failed} failed` : ""}
                    </Typography>
                  </Box>
                )}
                {formik.touched.imageURL && formik.errors.imageURL ? (
                  <Typography variant="caption" color="error" display="block" style={{ marginBottom: 8 }}>
                    {formik.errors.imageURL}
                  </Typography>
                ) : null}
                {(formik.values.imageURL || []).length > 0 ? (
                  renderUploadedMediaSection(formik.values.imageURL || [], removeImageAt)
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No files uploaded yet. Select images, videos, or audio, upload to Azure, then save.
                  </Typography>
                )}
              </Box>
            </Box> */}
          </DialogContent>
          <Divider />
          <DialogActions className={classes.dialogActions}>
            <Button onClick={handleClose} color="default" disabled={uploading}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.primaryBtn}
              disabled={!effectiveSchoolId || uploading}
            >
              {isEditMode ? "Update" : "Save"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={statusConfirmDialog.open}
        onClose={closeStatusConfirmDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ fontWeight: 700, color: "#0f2d4d" }}>
          {normalizeImageStoreStatus(statusConfirmDialog.newStatus) === "published"
            ? "Publish album?"
            : "Move to draft?"}
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
            <Typography variant="body2" style={{ color: "#46566b" }}>
              <strong style={{ color: "#e65100" }}>Draft</strong> — stays in this table only. Not sent to parents.
            </Typography>
            <Typography variant="body2" style={{ color: "#46566b" }}>
              <strong style={{ color: "#1a9b54" }}>Published</strong> — sent to parents on Student Story.
            </Typography>
            <Typography variant="body2" style={{ color: "#0f2d4d", marginTop: 4 }}>
              {normalizeImageStoreStatus(statusConfirmDialog.newStatus) === "published"
                ? "Publish this album?"
                : "Move this album back to draft?"}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "12px 20px" }}>
          <Button onClick={closeStatusConfirmDialog} style={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button
            onClick={confirmInlineStatusChange}
            color="primary"
            variant="contained"
            style={{ textTransform: "none" }}
          >
            {normalizeImageStoreStatus(statusConfirmDialog.newStatus) === "published"
              ? "Publish"
              : "Move to Draft"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={mediaPlayer.open}
        onClose={closeMediaPlayer}
        maxWidth="md"
        fullWidth
        PaperProps={{ className: classes.mediaPlayerDialog }}
      >
        <DialogTitle style={{ color: "#fff", backgroundColor: "#0f2d4d" }}>
          {mediaPlayer.title || (mediaPlayer.type === "video" ? "Video" : mediaPlayer.type === "audio" ? "Audio" : "Image")}
          <IconButton
            onClick={closeMediaPlayer}
            style={{ position: "absolute", right: 8, top: 8, color: "#fff" }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: 0, backgroundColor: "#000", textAlign: "center" }}>
          {mediaPlayer.type === "video" && (
            <video
              key={mediaPlayer.url}
              src={mediaPlayer.url}
              controls
              autoPlay
              className={classes.mediaPlayerVideo}
            />
          )}
          {mediaPlayer.type === "audio" && (
            <Box p={3}>
              <AudiotrackIcon style={{ color: "#1769d6", fontSize: 48, marginBottom: 16 }} />
              <audio key={mediaPlayer.url} src={mediaPlayer.url} controls autoPlay style={{ width: "100%" }} />
            </Box>
          )}
          {mediaPlayer.type === "image" && (
            <img
              src={mediaPlayer.url}
              alt={mediaPlayer.title || "Preview"}
              style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
